module.exports = __webpack_public_path__ + "img/star-4.3a7b6639.svg";